import { render, staticRenderFns } from "./AddLabelDialog.vue?vue&type=template&id=b08665ae&scoped=true&"
import script from "./AddLabelDialog.vue?vue&type=script&lang=js&"
export * from "./AddLabelDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddLabelDialog.vue?vue&type=style&index=0&id=b08665ae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08665ae",
  null
  
)

export default component.exports